/** Blog image width in the editor and the article preview. */
export const INLINE_IMAGE_MAX_WIDTH = 560;

/** Image inside rich text (editor, blog preview, markdown → HTML); each caller sets its own margin. */
export const inlineImageStyle = (maxWidth) => ({
  display: "block",
  maxWidth: `min(100%, ${maxWidth}px)`,
  maxHeight: `${Math.round(maxWidth * 0.75)}px`,
  width: "auto",
  height: "auto",
  borderRadius: "8px",
});

/** Same style as CSS declarations, for `<style>` blocks and `style` attributes. */
export const inlineImageCss = (maxWidth) =>
  Object.entries(inlineImageStyle(maxWidth))
    .map(([property, value]) => `${property.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}:${value};`)
    .join("");
